import React, { useState } from 'react'
import { styled } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { Switch } from '@mui/material'

import { setToggleEmailStatus } from '../../slices'
import { renderInlineLoading } from '../../../../core/utils'

const PREFIX = 'TableActions'

const classes = {
  root: `${PREFIX}-root`,
  switchBase: `${PREFIX}-switchBase`,
  track: `${PREFIX}-track`,
  checked: `${PREFIX}-checked`,
}

const StyledSwitch = styled(Switch)(({ theme }) => ({
  [`& .${classes.root}`]: {
    marginRight: 10,
  },

  [`& .${classes.switchBase}`]: {
    '&$checked': {
      color: theme.palette.common.white,
      '& + $track': {
        backgroundColor: theme.palette.primary.main,
      },
    },
  },

  [`& .${classes.track}`]: {
    backgroundColor: theme.palette.grey[500],
  },

  [`& .${classes.checked}`]: {},
}))

export const TableActions = ({ rowData, ...props }) => {
  const dispatch = useDispatch()
  const emails = useSelector((state) => state.emailManagement.data)
  const permissions = useSelector((state) => state.global.permissions)
  const [isLoading, setIsLoading] = useState(false)

  if (!rowData) {
    return null
  }

  const blackOrWhiteListed = rowData['tipo'] === 'black' ? false : true

  const handleToggleState = (e) => {
    e.stopPropagation()
    dispatch(setToggleEmailStatus(rowData, emails, setIsLoading))
  }

  return isLoading ? (
    renderInlineLoading()
  ) : (
    <div onClick={(e) => e.stopPropagation()}>
      <Switch
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          track: classes.track,
          checked: classes.checked,
        }}
        checked={blackOrWhiteListed}
        onClick={handleToggleState}
        disabled={!permissions['gestion_emails']}
      />
    </div>
  )
}
